import React, { useState, Component, useEffect } from "react";
import useStyles from "./styles";
import api from "../../../Axios/api";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Link } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import LibraryAddIcon from "@material-ui/icons/LibraryAdd";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import RemoveProfilePic from "../../../Components/FormDialog/RemoveProfilePic";
import ImageCropProfile from "../../../Components/FormDialog/ImageCropProfile";
import {
  useUserContext,
  updateProfile,
  logoutUser,
} from "../../../context/UserContext";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";

// MUI Components
import {
  Grid,
  Typography,
  Button,
  TextField,
  Avatar,
  Paper,
  Modal,
  FormLabel,
} from "@material-ui/core";
import {
  CheckCircle,
  DeleteForever,
  EditOutlined,
  FormatLineSpacing,
  RemoveCircleOutline,
} from "@material-ui/icons";

export default function AccountSettingsPage() {
  const classes = useStyles();
  const { store, dispatch } = useUserContext();
  const token = store.data.token;

  const [buyerData, setBuyerData] = useState({
    profilePic: store.data.data ? store.data.data.profilePic : null,
    name: store.data.data ? store.data.data.name : null,
    email: store.data.data ? store.data.data.email : null,
    phoneNumber: store.data.data ? store.data.data.phoneNumber : null,
    address: store.data.data ? store.data.data.address : null,
    isNotificationsEnabled: store.data.data
      ? store.data.data.isNotificationsEnabled
      : false,
  });
  const handleChange = (input) => (e) => {
    setBuyerData({ ...buyerData, [input]: e.target.value });
  };
  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };
  const [isProfilePicRemove, setIsProfilePicRemove] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = React.useState(false);
  const [openDeactivationDialog, setOpenDeactivationDialog] =
    React.useState(false);
  const [accountPassword, setAccountPassword] = useState(null);
  const [isNotificationOn, setIsNotificationOn] = React.useState({
    checkedA: buyerData.isNotificationsEnabled,
    checkedB: true,
  });

  const handleChangeNotification = (event) => {
    setIsNotificationOn({
      ...isNotificationOn,
      [event.target.name]: event.target.checked,
    });
    if (event.target.name === "checkedA" && event.target.checked) {
      buyerData.isNotificationsEnabled = true;
    } else {
      buyerData.isNotificationsEnabled = false;
    }
  };

  const handleClickOpenDeletionDialog = () => {
    setOpenDeletionDialog(true);
  };

  const handleCloseDeletionDialog = () => {
    setOpenDeletionDialog(false);
  };

  const handleClickOpenDeactivationDialog = () => {
    setOpenDeactivationDialog(true);
  };

  const handleCloseDeactivationDialog = () => {
    setOpenDeactivationDialog(false);
  };

  const onSelectlogo = (image) => {
    setBuyerData({ ...buyerData, profilePic: image });
  };

  // Show delete ProfilePic dialog
  const handlerRemoveProfilePic = (e) => {
    e.preventDefault();
    setIsProfilePicRemove(true);
  };

  const confirmedRemoveProfilePic = () => {
    setBuyerData({ ...buyerData, profilePic: "" });
    setIsProfilePicRemove(false);
  };
  // UPDATE REQUEST SENDING HERE
  const handleSubmitUpdate = (e) => {
    e.preventDefault();
    const storesData = store.data.data;
    if (
      buyerData.name === storesData.name &&
      buyerData.email === storesData.email &&
      buyerData.phoneNumber === storesData.phoneNumber &&
      buyerData.profilePic === storesData.profilePic &&
      buyerData.address === storesData.address &&
      buyerData.isNotificationsEnabled === storesData.isNotificationsEnabled
    ) {
      return setSnackBar({
        ...snackBarstate,
        type: "error",
        message: "No chanages made yet!",
        open: true,
      });
    }
    api
      .patch(
        "/buyer/me",
        {
          ...buyerData,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(async (res) => {
        const oldData = store.data.data;
        const newData = { ...oldData, ...buyerData };

        setTimeout(function () {
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "Your Profile has been updated!",
            open: true,
          });
          setTimeout(function () {
            updateProfile(dispatch, newData, token);
          }, 1000);
        }, 1000);
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: JSON.stringify(error.response.data.error.message),
          open: true,
        })
      );
  };

  // Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);

  const handleOpen = () => {
    setModelOpen(true);
  };

  const handleClose = () => {
    setModelOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const checkAccountPasswordAndDeleteAccount = () => {
    const dataToCheck = {
      email: store.data ? store.data.data.email : null,
      password: accountPassword,
    };
    api
      .post(
        "/buyer/checkCredentials",
        {
          ...dataToCheck,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(function (res) {
        //If correct password then delete account
        api
          .delete("/buyer/me", {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(function (res) {
            console.log("deleted", res.data);
            setSnackBar({
              ...snackBarstate,
              type: "success",
              message:
                "Account has been deleted and logged out from all devices successfully.",
              open: true,
            });
            localStorage.removeItem("CART_DATA");
            localStorage.removeItem("WISHLIST_DATA");
            window.location.href = `/buyer/login`;
            return logoutUser(dispatch);
          })
          .catch((error) => console.log("deletion error: ", error));
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: JSON.stringify(error.response.data.error.message),
          open: true,
        })
      );
  };

  const checkAccountPasswordAndDeactivateAccount = () => {
    const dataToCheck = {
      email: store.data ? store.data.data.email : null,
      password: accountPassword,
    };
    api
      .post(
        "/buyer/checkCredentials",
        {
          ...dataToCheck,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(function (res) {
        //If correct password then delete account
        api
          .get("/buyer/deActivateAccount", {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then(function (res) {
            // console.log("deactivated", res.data)
            setSnackBar({
              ...snackBarstate,
              type: "success",
              message:
                "Account has been deactivated successfully. You can login anytime to activate it.",
              open: true,
            });
            localStorage.removeItem("CART_DATA");
            localStorage.removeItem("WISHLIST_DATA");
            window.location.href = `/buyer/login`;
            return logoutUser(dispatch);
          })
          .catch((error) => console.log("deletion error: ", error));
      })
      .catch((error) =>
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: JSON.stringify(error.response.data.error.message),
          open: true,
        })
      );
  };
  return (
    <div>
      <div className={classes.mainAboutusContainer}>
        <Breadcrumbs
          style={{ paddingTop: 30, paddingBottom: 20 }}
          aria-label="breadcrumb"
        >
          <Link className={classes.bCrumbLink} style={{ color: "grey" }} to="/">
            Home
          </Link>
          <Link
            className={classes.bCrumbLink}
            style={{ color: "grey" }}
            to="/account"
          >
            My Account
          </Link>
          <Typography color="textPrimary">Settings</Typography>
        </Breadcrumbs>

        <div>
          <Grid container spacing={1} style={{ margin: "0px 0px 30px 0px" }}>
            <Grid item xs={12} sm={12} md={12} component={Paper}>
              <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                  <LibraryAddIcon />
                </Avatar>
                <Typography variant="h5">Edit Personal Details</Typography>

                <form className={classes.form}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        autoFocus
                        margin="dense"
                        variant="outlined"
                        autoComplete="fName"
                        required
                        fullWidth
                        label="Full Name"
                        name="name"
                        value={buyerData.name}
                        onChange={handleChange("name")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        required
                        fullWidth
                        label="Email"
                        id="email"
                        name="email"
                        value={buyerData.email}
                        onChange={handleChange("email")}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        variant="outlined"
                        margin="dense"
                        required
                        fullWidth
                        placeholder="Enter Contact"
                        label="Contact Number"
                        name="phoneNumber"
                        value={buyerData.phoneNumber}
                        onChange={handleChange("phoneNumber")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <TextField
                        margin="dense"
                        variant="outlined"
                        autoComplete="fName"
                        required
                        fullWidth
                        label="Address"
                        name="address"
                        value={buyerData.address}
                        onChange={handleChange("address")}
                      />
                    </Grid>
                  </Grid>
                  {/*///////////////////////// image upload option /////////////////////////////*/}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: 20,
                      marginBottom: 5,
                      padding: 20,
                      height: 160,
                      border: "1px solid #c4c4c4",
                      borderRadius: 6,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        alignItems: "center",
                      }}
                    >
                      <Avatar
                        alt="profile photo"
                        src={buyerData.profilePic}
                        className={classes.avatarInProfileSetting}
                      >
                        {"Pic HERE"}
                      </Avatar>
                      <div style={{ marginLeft: 20 }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleOpen}
                        >
                          <AddAPhotoIcon
                            style={{
                              marginRight: 5,
                              fontSize: 22,
                              marginBottom: 5,
                            }}
                          />
                          Upload
                        </Button>
                        <Button
                          onClick={handlerRemoveProfilePic}
                          variant="outlined"
                          className={classes.removeImageBtn}
                        >
                          Remove Image
                        </Button>
                      </div>
                    </div>
                  </div>
                  <FormLabel style={{ marginTop: 20 }} component="legend">
                    Receive System Notifications
                  </FormLabel>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={isNotificationOn.checkedA}
                        onChange={handleChangeNotification}
                        name="checkedA"
                      />
                    }
                    label={
                      buyerData.isNotificationsEnabled ? "Enabled" : "Disabled"
                    }
                  />

                  <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Button
                        style={{ width: "100%" }}
                        size="large"
                        type="submit"
                        fullWidth
                        variant="outlined"
                        color="primary"
                        onClick={handleSubmitUpdate}
                        className={classes.submit}
                      >
                        <CheckCircle style={{ marginRight: 8 }} />
                        Save Changes
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      {" "}
                      <Link
                        style={{ textDecoration: "none", color: "black" }}
                        to={"/change/password"}
                      >
                        <Button
                          size="large"
                          style={{ width: "100%", display: "flex" }}
                          fullWidth
                          variant="outlined"
                          // className={classes.submit}
                        >
                          <EditOutlined style={{ marginRight: 8 }} />
                          Change Password
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2} style={{ marginTop: 15 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Button
                        size="large"
                        style={{ width: "100%" }}
                        fullWidth
                        variant="outlined"
                        onClick={() => handleClickOpenDeactivationDialog()}
                      >
                        <RemoveCircleOutline style={{ marginRight: 8 }} />
                        Deactivate Account
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Button
                        size="large"
                        style={{
                          width: "100%",
                          backgroundColor: "red",
                          color: "white",
                        }}
                        fullWidth
                        variant="contained"
                        // className={classes.submit}
                        onClick={() => handleClickOpenDeletionDialog()}
                      >
                        <DeleteForever style={{ marginRight: 8 }} />
                        Delete Account
                      </Button>
                    </Grid>
                  </Grid>

                  <RemoveProfilePic
                    RemoveProfilePic={isProfilePicRemove}
                    setRemoveProfilePic={setIsProfilePicRemove}
                    confirmedRemoveProfilePic={confirmedRemoveProfilePic}
                  />
                  <Snackbar
                    open={open}
                    anchorOrigin={{ vertical, horizontal }}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackBar}
                    key={vertical + horizontal}
                  >
                    <MuiAlert
                      elevation={6}
                      variant="filled"
                      onClose={handleCloseSnackBar}
                      severity={snackBarstate.type}
                    >
                      {snackBarstate.message}
                    </MuiAlert>
                  </Snackbar>
                </form>
              </div>
            </Grid>
            <Modal
              open={modalOpen}
              onClose={handleClose}
              onBackdropClick={handleClose}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "#FFF",
                  width: "70vw",
                  height: "70vh",
                  padding: "20px",
                  position: "relative",
                }}
              >
                <ImageCropProfile
                  onProfileChange={onSelectlogo}
                  handleClose={handleClose}
                />
              </div>
            </Modal>
          </Grid>
        </div>

        {/* Deletion Dialog Box */}
        <div>
          <Dialog
            open={openDeletionDialog}
            onClose={handleCloseDeletionDialog}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Delete Account</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please Enter Your account password to delete your account
                permenantely.
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="password"
                label="Account Password"
                type="password"
                fullWidth
                onChange={(e) => setAccountPassword(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDeletionDialog} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => checkAccountPasswordAndDeleteAccount()}
                color="primary"
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>

        {/* Deactivation dialog */}
        <div>
          <Dialog
            open={openDeactivationDialog}
            onClose={handleCloseDeactivationDialog}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Deactivate Account</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Please Enter Your account password to deactivate your account.
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                id="password"
                label="Account Password"
                type="password"
                fullWidth
                onChange={(e) => setAccountPassword(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDeactivationDialog} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => checkAccountPasswordAndDeactivateAccount()}
                color="primary"
              >
                Deactivate
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </div>
  );
}
